import { request } from '../api.js';
import type { MarkUpdatesSeenRequest, TaskUpdateFeedResponse } from '@cosvision/shared';

export interface ListFeedQuery {
  officerId?: string;
  taskId?: string;
  unreadOnly?: boolean;
  limit?: number;
}

export function getTaskUpdateFeed(query: ListFeedQuery = {}): Promise<TaskUpdateFeedResponse> {
  const params = new URLSearchParams();
  if (query.officerId) params.set('officerId', query.officerId);
  if (query.taskId) params.set('taskId', query.taskId);
  if (query.unreadOnly) params.set('unreadOnly', 'true');
  if (query.limit) params.set('limit', String(query.limit));
  const qs = params.toString();
  return request<TaskUpdateFeedResponse>(
    'get',
    qs ? `/tasks/updates/feed?${qs}` : '/tasks/updates/feed',
  );
}

export function markUpdatesSeen(body: MarkUpdatesSeenRequest): Promise<{ marked: number }> {
  return request<{ marked: number }>('post', '/tasks/updates/mark-seen', body);
}
